export default __webpack_public_path__ + "static/media/Scopely_logo_color.01d5ea3f.png";